import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, Label } from "@/components/site/Reveal";

const faqs = [
  {
    q: "When exactly is the retreat?",
    a: "The retreat runs 24–27 September (Thursday to Sunday) — three nights and four days at The Manor House, Dehradun.",
  },
  {
    q: "Do I need to be 'into' music or meditation?",
    a: "Not at all. Everything is optional and unforced. Come for the sound, stay for the stillness, or just be there for the joy of it — the weekend flexes around you.",
  },
  {
    q: "How do I get to The Manor House in Dehradun?",
    a: "We're about 40 minutes from Jolly Grant Airport (Dehradun) and a short drive from the city centre. Airport transfers are included with the Manor Suite; we'll help arrange everything else.",
  },
  {
    q: "What's included in the rate?",
    a: "Three nights' stay, all meals and tonics, and full access to the programme — live sets, sound baths, breathwork and long-table dinners. Suites add wine pairings and priority access.",
  },
  {
    q: "Is it suitable for solo travellers?",
    a: "Absolutely — a good chunk of our guests come solo. The whole thing is designed around easy, unforced community. You won't feel like the odd one out.",
  },
];

const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="mx-auto max-w-7xl px-6 py-28 md:px-10 md:py-40">
    <div className="grid grid-cols-1 gap-16 md:grid-cols-12">
      <Reveal className="md:col-span-4">
        <Label>Questions</Label>
        <h2 className="mt-6 font-display text-4xl font-light tracking-tight text-manor-text sm:text-5xl">
          The practical bits.
        </h2>
      </Reveal>
      <div className="md:col-span-7 md:col-start-6">
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-white/10">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-6 text-left font-display text-xl font-light text-manor-text hover:text-manor-rust hover:no-underline md:text-2xl"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base font-light leading-relaxed text-manor-sage">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);

export default FAQ;
